import { QUERY_KEYS } from 'api/query-keys';
import { sharedPaymentService } from 'api/services';
import { useInfiniteQuery } from 'react-query';
import { Site } from 'shared/hooks';
import { DEFAULT_PAGE_SIZE } from 'shared/utils/constants';

export const useGetPayments = (page: number, site: Site) => {
  return useInfiniteQuery({
    queryKey: QUERY_KEYS.payments(),
    queryFn: async () =>
      await sharedPaymentService.getPaginatedPayments(site, page, DEFAULT_PAGE_SIZE),
    getNextPageParam: (lastGroup) => lastGroup.nextPage,
  });
};
